import { RootState } from '../../store';
import { getPlatformUserId } from '../../../utils/utils';

export const selectSelectedConversation = (state: RootState) => {
    const { conversations, selectedConversationId } = state.dashboard.askAicaReducer;
    if (!selectedConversationId) return null;
    return conversations.find((c) => c.conversation_id === selectedConversationId) ?? null;
};

export const selectViewOnly = (state: RootState): boolean => {
    const { selectedConversationId } = state.dashboard.askAicaReducer;
    if (!selectedConversationId) return false;
    const selectedRow = selectSelectedConversation(state);
    if (!selectedRow) return false;
    return selectedRow.user_id !== getPlatformUserId();
};
